import React from "react";
import {ConfiguredElement, ProductData, ProductElementModifier} from "../../providers/product/product-types";
import {AddNewElementButton} from "../product/AddNewElementButton";
import {ConfigChangeEvent} from "../product/Product";
import {ConfiguratorSection} from "./ConfiguratorSection";

export interface ConfiguratorProps {
    product: ProductData;
    config: ConfiguredElement[];
    onConfigChange: (ev: ConfigChangeEvent) => void;
}

const Configurator = ({product, config, onConfigChange}: ConfiguratorProps) => {
    const selectValues = product.elements.map(e => e.title);

    const addNewElement = () => {
        const newConfig = {
            config: product.elements[0],
            values: product.elements[0].params.reduce((acc, p) => ({...acc, [p.key]: p.defaultValue}), {height: 10}),
            modifiers: [],
        };

        onConfigChange({newConfig})
    }

    const changeConfigType = (index: number, value: string) => {
        const productElements = product.elements.find(e => e.title === value) || product.elements[0];
        const defaultValues = productElements.params.reduce((acc, p) => ({
            ...acc,
            [p.key]: p.defaultValue
        }), {height: 10});

        const newConfig = {
            config: productElements,
            values: defaultValues,
            modifiers: [],
        }

        onConfigChange({index, newConfig});
    }

    const onModifierAttach = (index: number, modifier: ProductElementModifier) => {
        const oldConfig = config[index];
        const newConfig = {
            config: oldConfig.config,
            values: {
                ...oldConfig.values,
                ...modifier.params.reduce((acc, p) => ({...acc, [p.key]: p.defaultValue}), {}),
            },
            modifiers: [...config[index].modifiers, modifier]
        }
        onConfigChange({index, newConfig});
    }

    const onModifierRemove = (index: number, modifierIndex: number) => {
        const oldConfig = config[index];
        const newModifiers = oldConfig.modifiers.filter((_, i) => i !== modifierIndex);
        onConfigChange({index, newConfig: {...oldConfig, modifiers: newModifiers}});
    }

    const changeConfigValue = (index: number, key: string, value: number | string) => {
        const newConfig = {...config[index]};
        newConfig.values[key] = value;
        onConfigChange({index, newConfig});
    }

    const onRemove = (index: number) => {
        onConfigChange({index});
    }

    return (
        <>
            {config.map((c, index) => (
                <ConfiguratorSection
                    index={index}
                    totalConfigLength={config.length}
                    key={index}
                    config={c}
                    selectValues={selectValues}
                    changeConfigType={changeConfigType}
                    changeConfigValue={changeConfigValue}
                    onModifierAttach={onModifierAttach}
                    onModifierRemove={onModifierRemove}
                    onRemove={onRemove}
                />
            ))}
            {config.length < product.maxElements ?
                <AddNewElementButton onClick={() => addNewElement()}/> : null}
        </>
    );
}

export default Configurator;